import React from 'react';
import LayoutHelper from 'helper/layout-helper';
import PropTypes from 'prop-types';

export const DefaultSecurityPageTemplate = ({ children }) => (
  <LayoutHelper.fullPageLayout className="security-page">
    <LayoutHelper.fullPageLayoutHeader/>
    <LayoutHelper.fullPageLayoutContent>
      <div className="row form-wrap form-wrap--security">
        <div className="form-wrap__inner">
          <div className="col-sm-6 col-md-5 col-lg-4 security-form">
            {children}
          </div>
        </div>
      </div>
    </LayoutHelper.fullPageLayoutContent>
  </LayoutHelper.fullPageLayout>
);

DefaultSecurityPageTemplate.propTypes = {
  children: PropTypes.any
};
